const PersonCount = ({ name, person, setPerson, placeholder }) => {
  return (
    <div className="relative z-0 mb-6 w-full group">
      <input
        type="number"
        name={name}
        id={name}
        className="block rounded-md py-5 px-6 w-full text-[0.875rem]  bg-transparent border border-gray-300 appearance-none   focus:outline-none focus:ring-0 focus:border-text-rezervation-form peer"
        placeholder=" "
        value={person}
        onChange={(e) => setPerson(e.target.value)}
      />
      <label
        htmlFor={name}
        className="peer-focus:font-medium absolute text-[0.875rem] text-[#A2B2B8] focus:text-text-rezervation-form  duration-300 transform -translate-y-6 scale-75 top-3 bg-white px-3  left-4 z-10 origin-[0] peer-focus:left-4 peer-focus:text-text-rezervation-form  peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:text-[0.875rem] peer-focus:-translate-y-6"
      >
        {placeholder}
      </label>
    </div>
  );
};

export default PersonCount;
